import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID, // Make sure this is set correctly
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const app = initializeApp(firebaseConfig);

// if (window.location.href.includes("localhost")) {
//   self.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.REACT_APP_DEBUG_DEV_LOCAL;
// }
// TODO: Add App Check

// Initialize Firestore and Auth
export const db = getFirestore(app);
export const dbCentral = db;

export const auth = getAuth(app);
export const authCentral = auth;
export const appCentral = app;

export default app;

export const getAuthCentral = () => {
  if (!authCentral) {
    throw new Error("Firebase Auth is not initialized");
  }
  return authCentral;
};
